import { makeStyles } from '@material-ui/styles'
import Badge from 'core/elements/badge/Badge'
import type Theme from 'core/themes/model'

const useStyles = makeStyles<Theme>((theme) => ({
  withBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  betaBadge: {
    display: 'inline',
    padding: theme.spacing(0, 1),
    fontSize: 12,
  },
}))

interface BetaLabelProps {
  text: string
}

// A label followed by the Beta badge, for tabs and menu items of features that ship as Beta
export default function BetaLabel({ text }: BetaLabelProps) {
  const classes = useStyles()
  return (
    <span className={classes.withBadge}>
      {text} <Badge className={classes.betaBadge} variant="primary" text="Beta" />
    </span>
  )
}
